/**
 * Standard avatar size classes for consistent layouts.
 * All sizes are in design-space pixels (540x960 base).
 */

export const AVATAR_SIZE_CLASSES = {
  /** Medium: 100×150 - Standard character size */
  MEDIUM: { w: 100, h: 150 },
  /** Small: 80×80 - Compact/square avatars (e.g., bats) */
  SMALL: { w: 80, h: 80 },
  /** Large: 120×180 - Hero/prominent characters */
  LARGE: { w: 120, h: 180 },
  /** Wide: 150×100 - Landscape-oriented avatars */
  WIDE: { w: 150, h: 100 },
  /** Tall: 100×200 - Extra-tall characters */
  TALL: { w: 100, h: 200 },
} as const;
